import axios from './../plugins/private-api-axios'

export const snapshotService = {
    urlPrefix: '/snapshots',
    config: {
        headers: {
            Authorization: ''
        }
    },
    async getSnapshots (page, perPage, type) {
        let urlBuilder = {
            'skip': (page - 1) * perPage,
            'take': perPage,
            'OrderBy': '-CreatedOn'
        }

        if (null !== type) {
            urlBuilder.SnapshotType = type
        }

        try {
            return await axios.get(`${this.urlPrefix}?${new URLSearchParams(urlBuilder).toString()}&SnapshotStatuses=Completed&SnapshotStatuses=Unprocessed`, this.config)
        } catch (e) {
            throw e
        }
    },
    async getSnapshot (uuid) {
        try {
            return await axios.get(`${this.urlPrefix}/${uuid}`, this.config)
        } catch (e) {
            throw e
        }
    },
    async createSnapshot (data) {
        try {
            return await axios.post(`${this.urlPrefix}`, data, this.config)
        } catch (e) {
            throw e
        }
    }
}

export const updateSnapshotService = (accessToken) => {
    snapshotService.config.headers.Authorization = accessToken
}

export default snapshotService
